import { useContext } from "react";
import { useSelector } from "react-redux";
import { AllocationWarning } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  warnings: AllocationWarning[];
  checkAllocationWarnings(
    request: Boundaries["checkAllocationWarnings"]["request"],
  ): void;
}

function useCheckAllocationWarnings(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isCheckAllocationWarningsRequestPending(),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isCheckAllocationWarningsRequestSuccess(),
    ),
    isRequestFailure: useSelector(() =>
      selector.isCheckAllocationWarningsRequestFailure(),
    ),
    warnings: useSelector(() => selector.getCheckAllocationWarnings()),
    checkAllocationWarnings: core.checkAllocationWarnings,
  };
}

export { useCheckAllocationWarnings };
